import { createSelector } from 'reselect';

import { filterRequestFormatter } from 'modules/interventions/utils';

/** @return {import("../reducers").ContactMembersReducer} */
const getState = (state) => state.contactMembers;

const getRoot = (state) => state;

const getProps = (_, props) => props;

const getDataState = createSelector(getState, (state) => state.data);

const getDataEntities = createSelector(getDataState, (state) => state.entities);

const getUIState = createSelector(getState, (state) => state.ui);

const getContactMembersByIds = createSelector(getDataEntities, getProps, (entities, ids = []) =>
  ids.reduce((acc, contactMemberId) => {
    const entity = entities[contactMemberId];
    if (entity) {
      return [...acc, entity];
    }
    return acc;
  }, []));

const getUIContactMembers = createSelector(getUIState, (state) => state.contactMembers);

const getContactMembersIds = createSelector(getUIContactMembers, (contactMembers) => contactMembers.ids);

export const getContactMembersLoading = createSelector(getUIContactMembers, (contactMembers) => contactMembers.loading);

export const getContactMembersPage = createSelector(getUIContactMembers, (contactMembers) => contactMembers.page);

export const getContactMembers = createSelector(getRoot, getContactMembersIds, getContactMembersByIds);

/** @type {import('../types').ContactMember} */
export const getContactMemberById = createSelector(
  getDataEntities,
  getProps,
  (entities, contactMemberId) => entities[contactMemberId]
);

const getFilters = createSelector(getUIState, (state) => state.filters);

export const getContactMembersParams = createSelector(
  getContactMembersPage,
  getFilters,
  ({ size, number }, filters) => {
    const formattedFilters = filterRequestFormatter(filters);

    return {
      size,
      page: number,
      projection: 'page',
      ...formattedFilters,
    };
  }
);

const getLoadingState = createSelector(getUIState, (ui) => ui.loading);

const getDeletingStack = createSelector(getLoadingState, (loading) => loading.deleting);

export const isDeleting = createSelector(getDeletingStack, getProps, (stack, id) => stack.includes(id));

const getUpdatingStack = createSelector(getLoadingState, (loading) => loading.updating);

export const isUpdating = createSelector(getUpdatingStack, getProps, (stack, id) => stack.includes(id));

export const getEditId = createSelector(getUIState, (ui) => ui.editing.id);

export const isEditModalOpen = createSelector(getEditId, (id) => Boolean(id));
